module.exports = __webpack_public_path__ + "media/application/images/wjc-white@2x-dca5c0e6f7119ea16e4ccd2ced27570840b9057dc2a66d1c58f323e6f70c9270.png";